import urls from "../../../../global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function passwordReset(email: string) {
  const body = {
    email: email,
  };
  try {
    const callParams = getNoAuthCallParams("POST", body);
    const response = await makeCall(urls.passwordReset, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
